/**
 * PostHog Feature Flag Keys
 * Central place for all PostHog feature flag constants
 *
 * Usage:
 *   import { FeatureFlagKeys } from '../constants/ff.posthog';
 *   const isEnabled = useFeatureFlag(FeatureFlagKeys.addDailyPayOption);
 */

export const FeatureFlagKeys = {
  addDailyPayOption: 'ARF-1866-add-daily-pay-option',
  credentialingV2: 'TEMP-13770-credentialing-v2',
  credentialingV2AdminLicensePage: 'TEMP-13770-credentialingV2-admin-license-page',
};
